module.exports = __webpack_public_path__ + "media/images/icon_job-cbae65f16704e908f665797fce4f9ae9.svg";